import { Download, FileSpreadsheet, FileText, Printer, Sheet } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { toastError } from '../ui'

/**
 * Dışa aktarım: kurumsal Excel (formüllü, grafikli) ve PDF sunucuda üretilir; CSV ve tarayıcıdan yazdırma isteğe bağlı.
 * Boş listede pasif.
 */
export function ExportMenu({
  onCsv,
  onPdf,
  onExcel,
  onCorporatePdf,
  disabled,
}: {
  onCsv?: () => void
  onPdf?: () => void
  onExcel?: () => Promise<unknown>
  onCorporatePdf?: () => Promise<unknown>
  disabled?: boolean
}) {
  const { t } = useTranslation()
  const [busy, setBusy] = useState(false)
  const run = (fn: () => Promise<unknown>) => {
    setBusy(true)
    fn()
      .catch(toastError)
      .finally(() => setBusy(false))
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={disabled || busy}>
          <Download />
          {busy ? t('finance.reports.preparing') : t('finance.reports.export')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-52">
        {onExcel ? (
          <DropdownMenuItem onSelect={() => run(onExcel)}>
            <Sheet />
            {t('finance.reports.excel')}
          </DropdownMenuItem>
        ) : null}
        {onCorporatePdf ? (
          <DropdownMenuItem onSelect={() => run(onCorporatePdf)}>
            <FileText />
            {t('finance.reports.corporatePdf')}
          </DropdownMenuItem>
        ) : null}
        {onPdf ? (
          <DropdownMenuItem onSelect={onPdf}>
            <Printer />
            {t('finance.reports.pdf')}
          </DropdownMenuItem>
        ) : null}
        {onCsv ? (
          <DropdownMenuItem onSelect={onCsv}>
            <FileSpreadsheet />
            {t('finance.reports.csv')}
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
